// extracted by mini-css-extract-plugin
module.exports = {"align_right":"opening_hours__align_right__Sgdjb text__text_align_right__kF6ZW","nowrap":"opening_hours__nowrap__9XW1h"};